import { SpecDetails } from "./SpecDetails";

export default SpecDetails;
